import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

interface Props {
  index: number;
  title: string;
  description: string;
  testId?: string;
}

export const ResumeListItem: React.FC<Props> = ({ index, title, description, testId }) => {
  return (
    <li data-testid={testId}>
      <Box direction="row" gap="spacing8">
        <Inscription weight={700} data-testid={`${testId}_index`}>{index}.</Inscription>
        <Box>
          <Inscription weight={700} data-testid={`${testId}_title`}>{title}</Inscription>
          <Inscription data-testid={`${testId}_description`}>{description}</Inscription>
        </Box>
      </Box>
    </li>
  );
};
